<template>
  <div>
    <div class="Content" v-if="family" ref="Content">
      <div class="Persons">
        <div class="nb-text">
          <div class="Header">NB:</div>
          Her kan du ændre i nedenstående oplysninger, der er registreret om dig
          og dit barn/dine børn i skolens elevadministrationssystem.<br />
        </div>
        <div class="Header" v-if="Children.length">
          <span v-if="Children.length > 1">Mine børn</span>
          <span v-else>Mit barn</span>
        </div>
        <div v-for="child of Children" class="Child">
          <span class="NameWrapper">
            <span>{{ child.fornavn }}</span> <span>{{ child.efternavn }}</span>
          </span>
          <div>
            <div
              v-if="!hideContact"
              class="Line"
              :class="{
                narrow:
                  placement == 'narrow' ||
                  ContainerWidth <
                    (child.samboende ? 36.8 : 25.5) * FontSize * 16,
              }"
            >
              <span class="_50 Email">
                <label v-bind:for="'Mail' + child.id">Email:</label>
                <input
                  type="text"
                  v-bind:id="'Mail' + child.id"
                  maxlength="60"
                  v-model="child.email"
                  :class="{
                    inputError: errorFields.includes('Mail' + child.id),
                  }"
                />
              </span>
              <span v-if="child.samboende" class="_25 PhoneMulti HomePhone">
                <label
                  v-bind:for="'Tlf' + child.id"
                  :class="{ red: changeHemmelig == true }"
                  ><span v-if="family.hemmeligt">Hemmeligt</span
                  ><span v-else>Hjemmets</span> tlf.nr.:
                  <a
                    href="#"
                    @click.prevent="showModalHemmelig = true"
                    class="modalHelp"
                    ><i class="fas fa-question-circle"></i></a
                ></label>
                <span class="input-group">
                  <span
                    class="input-group-text"
                    title="Hemmeligt telefonummer"
                    @click="checkboxHemmeligt"
                  >
                    <i
                      v-if="family.hemmeligt"
                      class="far fa-phone-slash hemmelig"
                    ></i>
                    <i v-else class="far fa-phone hemmelig"></i>
                    <b-form-checkbox
                      switch
                      v-model="family.hemmeligt"
                      @change="checkboxHemmeligt"
                    ></b-form-checkbox>
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    v-bind:id="'Tlf' + child.id"
                    v-model="family.telefon"
                    maxlength="14"
                    :class="{
                      inputError: errorFields.includes('Tlf' + child.id),
                    }"
                  />
                </span>
              </span>
              <span class="_25 PhoneMulti">
                <label v-bind:for="'Mobil' + child.id">Mobil nummer:</label>
                <input
                  type="text"
                  v-bind:id="'Mobil' + child.id"
                  v-model="child.mobil"
                  maxlength="14"
                  :class="{
                    inputError: errorFields.includes('Mobil' + child.id),
                  }"
                />
              </span>
            </div>
            <div
              v-if="child.alias_fornavn !== null"
              class="Line"
              :class="{
                narrow:
                  placement == 'narrow' || ContainerWidth < 31 * FontSize * 16,
              }"
            >
              <span class="_50 Name">
                <label v-bind:for="'AliasFirst' + child.id"
                  >Alias fornavn:
                  <a
                    href="#"
                    @click.prevent="showModalAlias = true"
                    class="modalHelp"
                    ><i class="fas fa-question-circle"></i></a
                ></label>
                <input
                  type="text"
                  v-bind:id="'AliasFirst' + child.id"
                  maxlength="25"
                  v-model="child.alias_fornavn"
                  :class="{
                    inputError: errorFields.includes('AliasFirst' + child.id),
                  }"
                />
              </span>
              <span class="_50 Name">
                <label v-bind:for="'AliasLast' + child.id"
                  >Alias efternavn:
                  <a
                    href="#"
                    @click.prevent="showModalAlias = true"
                    class="modalHelp"
                    ><i class="fas fa-question-circle"></i></a
                ></label>
                <input
                  type="text"
                  v-bind:id="'AliasLast' + child.id"
                  maxlength="25"
                  v-model="child.alias_efternavn"
                  :class="{
                    inputError: errorFields.includes('AliasLast' + child.id),
                  }"
                />
              </span>
            </div>
            <div
              v-if="child.samboende"
              class="Line"
              :class="{
                narrow:
                  placement == 'narrow' || ContainerWidth < 31 * FontSize * 16,
              }"
            >
              <span class="_50 Photo">
                <label v-bind:for="'Photo' + child.id">
                  Må barnet blive fotograferet af skolefotograf og må barnets
                  foto offentliggøres?<br />
                  At barnets foto offentliggøres betyder, at barnets foto vises
                  på klassegalleri i skolens elevadministrative system, og at
                  foto’et kan ses i Aula som barnets profilbillede.
                </label>
                <select
                  v-bind:id="'Photo' + child.id"
                  v-model="child.fototilladelse"
                >
                  <option
                    v-for="option in photoOptions"
                    v-bind:value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </span>
            </div>
          </div>
        </div>
        <div v-if="family.parent" class="Parent">
          <span class="Header">Forælder</span>
          <div>
            <span class="NameWrapper">
              <span>{{ family.parent.fornavn }}</span>
              <span>{{ family.parent.efternavn }}</span>
            </span>
            <div
              v-if="!hideContact"
              class="Line"
              :class="{
                narrow:
                  placement == 'narrow' ||
                  ContainerWidth < 23.5 * FontSize * 16,
              }"
            >
              <span class="_50 Email">
                <label v-bind:for="'Mail' + family.parent.id">Email:</label>
                <input
                  type="text"
                  v-bind:id="'Mail' + family.parent.id"
                  maxlength="60"
                  v-model="family.parent.email"
                  :class="{
                    inputError: errorFields.includes('Mail' + family.parent.id),
                  }"
                />
              </span>
              <span class="_25 PhoneMulti">
                <label v-bind:for="'Mobil' + family.parent.id"
                  >Mobil nummer:</label
                >
                <input
                  type="text"
                  v-bind:id="'Mobil' + family.parent.id"
                  v-model="family.parent.mobil"
                  maxlength="14"
                  :class="{
                    inputError: errorFields.includes(
                      'Mobil' + family.parent.id
                    ),
                  }"
                />
              </span>
            </div>
            <div
              class="Line"
              :class="{
                narrow:
                  placement == 'narrow' ||
                  ContainerWidth < (hideContact ? 31 : 23.5) * FontSize * 16,
              }"
            >
              <span class="_50 Work">
                <label v-bind:for="'Arbejdssted' + family.parent.id"
                  >Arbejdssted:</label
                >
                <input
                  type="text"
                  v-bind:id="'Arbejdssted' + family.parent.id"
                  maxlength="60"
                  v-model="family.parent.arbejdssted"
                  :class="{
                    inputError: errorFields.includes(
                      'Arbejdssted' + family.parent.id
                    ),
                  }"
                />
              </span>
              <span v-if="!hideContact" class="_25 PhoneMulti">
                <label v-bind:for="'Arbejde' + family.parent.id"
                  >Arbejdstlf.:</label
                >
                <input
                  type="text"
                  v-bind:id="'Arbejde' + family.parent.id"
                  v-model="family.parent.arbejdstelefon"
                  maxlength="14"
                  :class="{
                    inputError: errorFields.includes(
                      'Arbejde' + family.parent.id
                    ),
                  }"
                />
              </span>
            </div>
            <div
              v-if="family.parent.alias_fornavn !== null"
              class="Line"
              :class="{
                narrow:
                  placement == 'narrow' || ContainerWidth < 31 * FontSize * 16,
              }"
            >
              <span class="_50 Name">
                <label v-bind:for="'AliasFirst' + family.parent.id"
                  >Alias fornavn:
                  <a
                    href="#"
                    @click.prevent="showModalAlias = true"
                    class="modalHelp"
                    ><i class="fas fa-question-circle"></i></a
                ></label>
                <input
                  type="text"
                  v-bind:id="'AliasFirst' + family.parent.id"
                  maxlength="25"
                  v-model="family.parent.alias_fornavn"
                  :class="{
                    inputError: errorFields.includes(
                      'AliasFirst' + family.parent.id
                    ),
                  }"
                />
              </span>
              <span class="_50 Name">
                <label v-bind:for="'AliasLast' + family.parent.id"
                  >Alias efternavn:
                  <a
                    href="#"
                    @click.prevent="showModalAlias = true"
                    class="modalHelp"
                    ><i class="fas fa-question-circle"></i></a
                ></label>
                <input
                  type="text"
                  v-bind:id="'AliasLast' + family.parent.id"
                  maxlength="25"
                  v-model="family.parent.alias_efternavn"
                  :class="{
                    inputError: errorFields.includes(
                      'AliasLast' + family.parent.id
                    ),
                  }"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="Buttons"
        :class="{ Reverse: ButtonsWrapped === true }"
        ref="Buttons"
      >
        <div>
          <button
            v-bind:class="status"
            type="button"
            v-on:click="SaveData()"
            v-bind:disabled="!changed || busy"
          >
            <i v-if="busy" class="fa fa-spinner fa-spin"></i>Gem
          </button>
          <div v-if="message" v-bind:class="status" class="message">
            {{ message }}
          </div>
        </div>
        <div class="Logo">
          <svg
            v-on:click="OpenKMD()"
            id="KMD_Logo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 756.6 253.4"
          >
            <path
              fill="#101820"
              d="M323.9 84.9c-.6-.7-.6-2.5 0-3.2l55.3-72.4c2.4-2.9 1.7-5.3 1.2-6.2-.4-.9-1.8-3.1-5.5-3.1h-41.5c-3.6 0-8.1 2.2-10.3 5.1 0 0-33 43-42.9 56v-53c0-4.5-3.7-8.2-8.1-8.2h-32.7c-4.5 0-8.2 3.7-8.2 8.2v153.3c0 4.5 3.7 8.2 8.2 8.2h32.7c4.5 0 8.1-3.7 8.1-8.2v-56.3c10.3 13.3 45.3 59.6 45.3 59.6 2.2 2.9 7.1 4.9 10.8 4.9h40.9c3.7 0 5.1-2.1 5.6-3.1.4-.9 1.2-3.4-1.2-6.2l-57.7-75.4z"
            />
            <path fill="#37A539" d="M0 0h168.7v169.7H0z" />
            <path
              fill="#101820"
              d="M670.9 0h-52.3c-4.5 0-8.2 3.7-8.2 8.2v26.4c0 4.5 3.7 8.2 8.2 8.2h44.5c26.4 0 42.8 16.1 42.8 42.1 0 26.4-16.1 42.1-43.2 42.1h-63.4c-.9 0-1.9-.9-2-1.8L577.6 7.6c-.6-4.2-4.5-7.6-8.8-7.6l-32 .1c-4 0-8.2 2.7-9.7 6.4 0 0-23.9 59.4-30.2 74.9-5.9-15.6-30.1-74.7-30.1-74.7-1.4-3.8-5.5-6.7-9.6-6.6l-29.6.1c-4.3-.2-8.5 3.2-9.4 7.6l-25.9 153.5c-.1 2 .4 4.2 1.8 5.9 1.4 1.7 3.5 2.6 5.7 2.6h32.5c4.3 0 8.3-4.2 8.9-8.4 0 0 8.1-55.9 11-76.3 7.9 20 31.5 78.1 31.5 78.1 1.5 3.8 5.6 6.6 9.7 6.6h7.3c4 0 8.2-2.8 9.7-6.5 0 0 23.6-58.2 31.9-78.2 2.6 20.5 9.7 77 9.7 77 .5 4.3 4.4 7.7 8.7 7.7h110.2c47.3 0 85.7-38.1 85.7-84.9 0-46.8-38.5-84.9-85.7-84.9"
            />
            <g fill="#101820">
              <path
                d="M422 243.8h-2.9c-.4 0-.7-.3-.8-.7l-3.2-11.2h-12.7l-3.1 11.2c-.1.4-.5.7-.9.7h-2.9c-.5 0-.8-.3-.8-.8v-.3l9-31.8c.8-3 3.1-3.7 5-3.7 1.8 0 4.1.7 4.9 3.7l9 31.9v.3c.3.4 0 .7-.6.7zm-12.2-31.9c-.1-.5-.4-.9-.9-.9s-.8.3-1 .9l-4.5 16.1h10.8l-4.4-16.1zM447.2 243.8h-2.3c-.5 0-1-.4-1-1v-16.1c0-4.9-1.7-6.5-5.4-6.5-2.1 0-4.4.8-6.6 1.9v20.6c0 .5-.4 1-1 1h-2.4c-.5 0-.9-.4-.9-1v-24.9c0-.5.4-1 .9-1h2.4c.5 0 .9.4.9 1v.9c2.7-1.5 4.9-2.2 7.8-2.2 5.9 0 8.5 3.7 8.5 10.2v16.1c.1.6-.3 1-.9 1zM491.6 243.8h-3c-.8 0-1.3-.3-1.6-.8l-15.1-28.7c0-.1-.1-.1-.1-.1V242.9c0 .5-.4.9-.9.9h-2.5c-.5 0-.9-.1-.9-.6v-34.4c0-.8.6-1.4 1.4-1.4h2.7c1.4 0 1.6.2 2 1l15 28.6.1.1V208.4c0-.5.4-.9.9-.9h2.6c.5 0 .9.4.9.9v34c-.1.8-.7 1.4-1.5 1.4zM520.6 243.9c-1.9.2-6.7.2-9.5.2-6.8 0-10.4-2.6-10.4-9.1v-18.8c0-6.5 3.6-9.1 10.4-9.1 2.9 0 7.5.1 9.5.3.3.1.5.4.5.7v2.4c0 .3-.2.6-.5.6h-9.4c-5.2 0-6 1.4-6 5.1v6.8h15c.5 0 1 .4 1 1v1.9c0 .5-.4 1-1 1h-15v8.2c0 3.7.8 5.1 6 5.1h9.4c.3 0 .5.2.5.6v2.5c0 .2-.2.6-.5.6zM547.8 243.5c-2.1.4-4 .6-8.1.6-6 0-12.9-3.2-12.9-15.1v-6.8c0-12 6.9-15.1 12.9-15.1 3.1 0 6.1.4 8.2.8.4 0 .8.2.8.6v2.5c0 .3-.1.5-.6.5h-.1c-1.8-.1-5.4-.4-8.2-.4-4.8 0-8.5 2.8-8.5 11.1v6.8c0 8.2 3.7 11.1 8.5 11.1 2.8 0 6.3-.2 8.1-.4h.2c.5 0 .8.2.8.8v2c-.2.6-.6.9-1.1 1zM586.5 243.5c-2.1.4-4 .6-8.1.6-6 0-12.9-3.2-12.9-15.1v-6.8c0-12 6.9-15.1 12.9-15.1 3.1 0 6.1.4 8.2.8.4 0 .8.2.8.6v2.5c0 .3-.1.5-.6.5h-.1c-1.8-.1-5.4-.4-8.2-.4-4.8 0-8.5 2.8-8.5 11.1v6.8c0 8.2 3.7 11.1 8.5 11.1 2.8 0 6.3-.2 8.1-.4h.2c.5 0 .8.2.8.8v2c-.1.6-.6.9-1.1 1zM602 244.2c-7.2 0-10.9-4.7-10.9-11.9v-3.7c0-7.2 3.7-11.9 10.9-11.9s10.9 4.7 10.9 11.9v3.7c0 7.1-3.7 11.9-10.9 11.9zm6.6-15.7c0-5-2-8.2-6.6-8.2-4.5 0-6.6 3.1-6.6 8.2v3.7c0 5 2 8.2 6.6 8.2 4.5 0 6.6-3.1 6.6-8.2v-3.7zM650.1 243.8h-2.3c-.5 0-1-.4-1-1v-17.3c0-4.1-1.9-5.2-4.5-5.2-1.8 0-3.8.6-5.7 1.3.3 1.1.4 2.3.4 3.8v17.4c0 .5-.3 1-.9 1h-2.6c-.5 0-.8-.4-.8-1v-17.4c0-4.3-1.2-5.1-3.8-5.1-1.8 0-3.9.9-6 1.9v20.6c0 .5-.3 1-.9 1h-2.6c-.5 0-.8-.4-.8-1v-24.9c0-.5.4-1 .9-1h2.4c.5 0 .9.4.9 1v.9c2-1.2 4.5-2.3 7.1-2.3 2.1 0 3.7.6 4.9 2 2.7-1.3 5.6-2 8.1-2 4.4 0 7.9 2.2 7.9 9v17.3c.2.6-.2 1-.7 1zM667.7 244.2c-1.5 0-3.8-.2-5.7-.5v8.9c0 .5-.4.9-.9.9h-2.5c-.5 0-.9-.4-.9-.9v-33.7c0-.6.1-.9 1-1.1 2.6-.6 6-1.1 9-1.1 7.3 0 10.7 4.7 10.7 12.1v3.5c0 7.6-3.5 11.9-10.7 11.9zm6.4-15.5c0-5.1-1.5-8.5-6.4-8.5-2.1 0-4.4.2-5.7.5v19.4c1.6.3 4.2.5 5.7.5 4.8 0 6.4-3.1 6.4-8.4v-3.5zM701.9 243.8h-2.2c-.5 0-1-.4-1-1v-1.1c-2.3 1.4-4.8 2.4-7.5 2.4-4.2 0-8-1.8-8-7.9v-.6c0-5.3 3.1-7.9 11.8-7.9h3.6v-2c0-4.1-1.4-5.5-5.2-5.5-3.2 0-5.5.2-7.5.4h-.2c-.4 0-.9-.1-.9-.8v-1.7c0-.5.3-.8 1-.9 2-.3 4.3-.6 7.6-.6 6.8 0 9.5 3.4 9.5 9.2v17.1c0 .5-.5.9-1 .9zm-3.3-13H695c-5.9 0-7.5 1.3-7.5 4.8v.6c0 3.5 1.7 4.5 4.5 4.5 2.2 0 4.3-.7 6.6-2v-7.9zM729.1 243.8h-2.3c-.5 0-1-.4-1-1v-16.1c0-4.9-1.7-6.5-5.4-6.5-2.1 0-4.4.8-6.6 1.9v20.6c0 .5-.4 1-1 1h-2.4c-.5 0-.9-.4-.9-1v-24.9c0-.5.4-1 .9-1h2.4c.5 0 .9.4.9 1v.9c2.7-1.5 4.9-2.2 7.8-2.2 5.9 0 8.5 3.7 8.5 10.2v16.1c.1.6-.3 1-.9 1zM756.5 218.1l-8.1 28.2c-1.5 5.3-3.3 7.2-8.9 7.2-1.4 0-3.1-.2-4.1-.4-.6-.1-1-.3-1-.8v-1.8c0-.5.4-.8.9-.8h.1c1.1.1 3.3.3 4.4.3 2.8 0 4-.7 4.8-4.2l.5-2h-.7c-1.5 0-2.7-.3-3.6-3.4l-6.5-22.4c-.1-.1-.1-.2-.1-.3 0-.5.3-.8.9-.8h2.7c.4 0 .7.4.8.8l5.8 21.2c.2 1 .6 1.1.9 1.1h.8l6-22.4c.1-.4.5-.7.9-.7h2.7c.5 0 .8.3.8.8.1.2.1.3 0 .4z"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
    <div v-else-if="communicationError && communicationError.length">
      {{ communicationError }}
    </div>
    <div v-else>Henter data <i class="fa fa-spinner fa-spin"></i></div>
    <b-modal
      id="HemmeligModal"
      v-model="showModalHemmelig"
      title="Hemmeligt telefonnummer"
      size="md"
      ok-only
      ok-title="Luk"
      centered
    >
      Du har mulighed for at angive om der er tale om hemmeligt telefonnummer,
      ved at anvende ikonet
      <span><b-form-checkbox switch class="help-toggle"></b-form-checkbox></span
      >, før feltet.
    </b-modal>
    <b-modal
      id="AliasModal"
      v-model="showModalAlias"
      title="Alias navne"
      size="md"
      ok-only
      ok-title="Luk"
      centered
    >
      Hvis en person har adresse- eller navnebeskyttelse i folkeregisteret,
      vises personens navn ikke i Aula.<br />
      I stedet vises et aliasnavn (F i fornavn og E i efternavn). Aliasnavnene
      kan rettes her.
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    axios: Function,
    getAulaToken: Function,
    childFilter: Array,
    placement: String,
  },
  data: () => ({
    api: "https://api.laererservices.dk/api/kontaktoplysninger",
    ContainerWidth: null,
    FontSize: 0,
    ButtonsWrapped: false,
    message: "",
    status: "",
    changed: false,
    valid: true,
    aulaToken: null,
    family: null,
    oldFamily: null,
    changeHemmelig: false,
    errorFields: [],
    communicationError: "",
    busy: false,
    changeHemmeligTimer: null,
    showModalHemmelig: false,
    showModalAlias: false,
    tokenFunction: null,
    saveCounter: 0,
    tracker: null,
    hideContact: true,
    photoOptions: [
      { text: "Mit barn må fotograferes, og foto må offentliggøres", value: 4 },
      {
        text: "Mit barn må fotograferes, men foto må IKKE offentliggøres",
        value: 3,
      },
      { text: "Mit barn må ikke fotograferes", value: 0 },
    ],
  }),
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  created: function () {
    this.tokenFunction = this.LoadData;
    this.aulaToken = this.getAulaToken();
    window.addEventListener("resize", this.handleWindowResize);
  },
  mounted: function () {},
  updated: function () {
    this.getFontSize();
    if (!this.ContainerWidth) {
      this.handleWindowResize();
    }
  },
  watch: {
    family: {
      handler(n, o) {
        if (o) {
          if (this.oldFamily.hemmeligt !== this.family.hemmeligt) {
            this.changeHemmelig = true;
            clearTimeout(this.changeHemmeligTimer);
            this.changeHemmeligTimer = setTimeout(() => {
              this.changeHemmelig = false;
            }, 500);
          }
          this.validateDelayed();
          this.changed = true;
          this.oldFamily = JSON.parse(JSON.stringify(this.family));
        }
      },
      deep: true,
    },
    aulaToken: function () {
      if (this.aulaToken) {
        if (this.tokenFunction) {
          this.tokenFunction.apply(this);
          this.tokenFunction = null;
        }
      } else {
        this.communicationError =
          "Vi kunne ikke modtage Login-data fra Aula, prøv evt. at genopfriske browseren.";
      }
    },
  },
  computed: {
    Children: function () {
      if (this.family && this.family.children) {
        return this.family.children;
      }
      return {};
    },
  },
  methods: {
    checkboxHemmeligt: function (e) {
      this.family.hemmeligt = !this.family.hemmeligt;
      e.preventDefault();
      e.stopPropagation();
      return;
    },
    debounce: function (func, delay) {
      const context = this;
      clearTimeout(this.tracker);
      this.tracker = setTimeout(() => func.apply(context), delay);
    },
    OpenKMD: function () {
      window.open("https://kmd.dk/", "_blank");
    },
    SaveData: function () {
      this.busy = true;
      this.message = "";
      if (!this.validateForm()) {
        this.status = "red";
        this.busy = false;
        return;
      }

      const config = {
        method: "post",
        headers: {
          Authorization: this.aulaToken,
          Accept: "application/json, text/plain",
        },
        data: this.mapSaveData(),
        url: this.api,
      };

      this.axios(config)
        .then((response) => {
          if (!response.data.Status) {
            this.message = "Fejl i kommunikationen.";
            this.status = "red";
            return;
          }
          let errorsExist = false;
          response.data.Status.forEach((s) => {
            if (s.kode !== 0) {
              this.message += s.tekst + "\n";
              errorsExist = true;
            }
          });
          if (errorsExist) {
            this.status = "red";
          } else {
            this.status = "green";
            this.message = "Ændringer gemt.";
            setTimeout(() => {
              this.status = ""; /*this.message = '';*/
            }, 1500);
            this.changed = false;
          }
          this.saveCounter = 0;
        })
        .catch((e) => {
          this.status = "red";
          if (
            e.response &&
            e.response.data &&
            e.response.data.ExceptionMessage
          ) {
            this.message = e.response.data.ExceptionMessage;
          } else if (e.response && e.response.status === 401) {
            if (this.saveCounter === 0) {
              //retry save
              this.saveCounter++;
              this.tokenFunction = this.SaveData;
              this.aulaToken = this.getAulaToken();
              this.message =
                "Dit Aula-login er udløbet. Vi forsøger at forny det, prøver at gemme igen.";
              return;
            }
            this.message = "Uautoriseret adgang.";
          } else if (e && e.message) {
            this.message = e.message;
          } else {
            this.message = "Noget er gået galt.";
          }
          this.saveCounter = 0;
        })
        .finally(() => {
          if (this.saveCounter === 0) {
            this.busy = false;
          }
        });
    },
    LoadData: function () {
      this.busy = true;
      const config = {
        method: "get",
        headers: {
          Authorization: this.aulaToken,
          Accept: "application/json, text/plain",
        },
        url: this.api,
      };

      this.axios(config)
        .then((response) => {
          this.family = this.mapLoadData(response.data);
          this.oldFamily = JSON.parse(JSON.stringify(this.family));
          this.busy = false;
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.Message) {
            this.communicationError = e.response.data.Message;
          } else if (e.response && e.response.status === 401) {
            this.communicationError = "Uautoriseret adgang.";
          } else if (e && e.message) {
            this.communicationError = e.message;
          } else {
            this.communicationError = "Noget er gået galt";
          }
          this.busy = false;
        });
    },
    mapLoadData: function (Kontaktoplysninger) {
      let family = {};
      family.parent = Kontaktoplysninger.kontaktperson;
      if (Array.isArray(Kontaktoplysninger.elev)) {
        family.children = Kontaktoplysninger.elev;
      } else {
        family.children = [Kontaktoplysninger.elev];
      }
      let first = true;
      family.children.forEach((c) => {
        if (c.samboende) {
          c.samboende = c.samboende === "X";
          if (first) {
            family.telefon = c.telefon;
            family.hemmeligt = c.hemmeligt_nummer === "X";
            first = false;
          }
        }
      });
      return family;
    },
    mapSaveData: function () {
      let kontaktoplysninger = {};
      kontaktoplysninger.kontaktpersoner = [this.family.parent];
      kontaktoplysninger.elev = JSON.parse(JSON.stringify(this.Children));
      kontaktoplysninger.elev.forEach((c) => {
        if (c.samboende) {
          c.samboende = "X";
          c.telefon = this.family.telefon;
          c.hemmeligt_nummer = this.family.hemmeligt ? "X" : "";
        }
        c.aendret_af_id = this.family.parent.id;
      });
      return kontaktoplysninger;
    },
    validateDelayed: function () {
      this.debounce(function () {
        this.validateForm();
      }, 500);
    },
    validateForm: function () {
      this.valid = true;
      this.errorFields = [];
      this.message = "";
      let message = "";
      this.Children.forEach((child) => {
        message = this.validatePerson(child);
        if (message) {
          this.message += message;
        }
      });
      message = this.validatePerson(this.family.parent);
      if (message) {
        this.message += message;
      }
      if (this.valid) {
        this.status = "";
      } else {
        this.status = "red";
      }

      return this.valid;
    },
    validatePerson: function (person) {
      let valid = true;
      let errors = [];
      let message = person.fornavn + " har fejl i ";
      let ascii = /^[\x20-\xFF]*$|^$/u;
      if (!this.hideContact && person.email !== undefined) {
        if (!ascii.test(person.email)) {
          errors.push("email (ugyldigt tegn)");
          this.errorFields.push("Mail" + person.id);
          valid = false;
        } else {
          if (!this.validEmail(person.email)) {
            errors.push("email");
            this.errorFields.push("Mail" + person.id);
            valid = false;
          }
        }
      }
      if (person.alias_fornavn !== null) {
        if (person.alias_fornavn.length === 0) {
          errors.push("alias fornavn");
          this.errorFields.push("AliasFirst" + person.id);
          valid = false;
        } else {
          if (!ascii.test(person.alias_fornavn)) {
            errors.push("alias fornavn (ugyldigt tegn)");
            this.errorFields.push("AliasFirst" + person.id);
            valid = false;
          }
        }
        if (person.alias_efternavn.length === 0) {
          errors.push("alias efternavn");
          this.errorFields.push("AliasLast" + person.id);
          valid = false;
        } else {
          if (!ascii.test(person.alias_efternavn)) {
            errors.push("alias efternavn (ugyldigt tegn)");
            this.errorFields.push("AliasLast" + person.id);
            valid = false;
          }
        }
      }
      if (!this.hideContact && person.mobil && person.mobil.length !== 0) {
        if (!ascii.test(person.mobil)) {
          errors.push("mobil (ugyldigt tegn)");
          this.errorFields.push("Mobil" + person.id);
          valid = false;
        }
      }
      if (person.arbejdssted && person.arbejdssted.length !== 0) {
        if (!ascii.test(person.arbejdssted)) {
          errors.push("arbejdssted (ugyldigt tegn)");
          this.errorFields.push("Arbejdssted" + person.id);
          valid = false;
        }
      }
      if (
        !this.hideContact &&
        person.arbejdstelefon &&
        person.arbejdstelefon.length !== 0
      ) {
        if (!ascii.test(person.arbejdstelefon)) {
          errors.push("arbejdstlf. (ugyldigt tegn)");
          this.errorFields.push("Arbejde" + person.id);
          valid = false;
        }
      }
      if (!this.hideContact && person.samboende) {
        if (!ascii.test(this.family.telefon)) {
          errors.push("telefon (ugyldigt tegn)");
          this.errorFields.push("Tlf" + person.id);
          valid = false;
        }
      }

      if (!valid) {
        if (errors.length > 1) {
          message += [errors.slice(0, -1).join(", "), errors.slice(-1)[0]].join(
            errors.length < 2 ? "" : " og "
          );
        } else {
          message += errors[0];
        }

        this.valid = false;
        return message + "\n";
      }
    },
    validEmail: function (email) {
      if (!email) return true;
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/u;
      return re.test(email);
    },
    handleWindowResize: function (event) {
      this.debounce(this.WindowResize, 50);
    },
    WindowResize: function () {
      if (this.$refs.Content && this.$refs.Content.clientWidth) {
        this.ContainerWidth = this.$refs.Content.clientWidth;
      }
      if (this.$refs.Buttons && this.$refs.Buttons.offsetTop) {
        this.ButtonsWrapped = this.$refs.Buttons.offsetTop > 0;
      } else {
        this.ButtonsWrapped = false;
      }
    },
    getFontSize: function () {
      let el = this.$refs.Content;
      if (el) {
        let style = window
          .getComputedStyle(el, null)
          .getPropertyValue("font-size");
        let fontSize = parseFloat(style);
        this.FontSize = (fontSize / 16) * (1 / 0.75);
      }
    },
  },
};
</script>

<style scoped>
Label {
  text-transform: initial;
  margin-bottom: 0;
}

button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 0;
  padding: 14px 44px;
  font-size: 15px;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  background: #19425f;
  color: #fff;
  border-radius: 4px;
}

.Content {
  position: relative;
  display: flex;
  font-size: 0.75em;
  flex-wrap: wrap;
}

.nb-text {
  font-size: 0.9em;
}

.nb-text > .Header {
  font-size: 1.2em;
}

input[type="text"],
select {
  height: 37px;
  width: 100%;
  margin-top: 2px;
  line-height: 1;
  margin-bottom: 10px;
  font-size: 12px;
  border-radius: 5px;
  border: 1px solid #d9e3e9;
}

.custom-switch ::v-deep  input[type="checkbox"] {
  position: relative;
  top: 2px;
}

.PhoneMulti .input-group input[type="text"] {
  min-height: 37px;
  height: unset;
  border: 1px solid #d9e3e9;
}

.PhoneMulti .input-group .input-group-text {
  margin-top: 2px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  height: 37px;
}

.PhoneMulti .input-group .input-group-text .hemmelig {
  position: relative;
  top: 0.1em;
  left: -0.6em;
}

.PhoneMulti .input-group .input-group-text .custom-switch {
  padding-left: unset;
}

.PhoneMulti
  .input-group
  .input-group-text
  ::v-deep
  .custom-switch
  .custom-control-label {
  left: 1.75em;
  top: -1.45em;
  display: block;
}

.PhoneMulti .input-group input[type="text"] {
  padding: 10px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 1%;
}

.PhoneMulti .input-group .input-group-text {
  padding-right: 0.2em;
}

.PhoneMulti .input-group .input-group-text .custom-switch {
  transform: rotate(-90deg);
  left: -0.2em;
}

.PhoneMulti .input-group .input-group-text .hemmelig {
  top: unset;
}

.PhoneMulti .input-group input:focus {
  box-shadow: none;
}

.help-toggle {
  display: inline-block;
  transform: rotate(-90deg);
  top: -0.2em;
  left: -1.5em;
  width: 1em;
}

.Logo {
  position: relative;
  margin: 0 0 0 auto;
  width: 12em;
  cursor: pointer;
}

.Persons {
  order: 1;
  flex: 1 1 auto;
  margin-right: 1em;
  min-width: 78%;
  margin: 0;
}

.Buttons {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  position: relative;
  width: 20em;
  order: 2;
  flex: 1 0 auto;
}

.Buttons.Reverse {
  flex-direction: column;
}

.Buttons button {
  padding-left: 0;
  padding-right: 0;
  margin-top: 0.5em;
  margin-bottom: 0.8em;
  width: 15em;
}

.Buttons button:disabled {
  background-color: rgb(210, 210, 210);
  cursor: initial;
}

.Buttons button.green {
  background-color: green;
}

.Buttons button.red {
  background-color: red;
}

.message {
  white-space: pre-line;
  margin-bottom: 0.5em;
}

.message.red,
.Line .red {
  color: red;
}

.message.green {
  color: green;
}

.modalHelp {
  color: blue;
  cursor: pointer;
}

.Header {
  font-size: 1.4em;
}

.Child {
  margin-bottom: 1.3em;
}

.inputError,
.PhoneMulti .input-group .inputError {
  border-color: red;
}

.NameWrapper {
  font-size: 1.1em;
  text-decoration: underline;
}

.Line {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.Line > span {
  padding-right: 0.5em;
}

._100,
.narrow ._50 {
  width: 100%;
}

._50,
.narrow ._25 {
  width: 50%;
}

._25 {
  width: 25%;
}

.Email,
.Name,
.Photo,
.Work {
  min-width: 20em;
}

.PhoneMulti {
  min-width: 10em;
}

.HomePhone {
  min-width: 12em;
}

.sup {
  vertical-align: super;
  font-size: 0.7em;
}
</style>
